<script>
	// @ts-nocheck
	/* eslint-disable max-lines */
	import { signIn } from '@auth/sveltekit/client';
	import { PUBLIC_SITE_URL } from '$env/static/public';
	import LoadingModal from '$lib/components/LoadingModal.svelte';
	import { Crisp } from 'crisp-sdk-web';
	import mixpanel from 'mixpanel-browser';
	import { superForm } from 'sveltekit-superforms/client';
	import SuperDebug from 'sveltekit-superforms/client/SuperDebug.svelte';
	import ErrorModal from './components/ErrorModal.svelte';
	import { signUpPageOneValidation } from '$lib/helpers/validations/registration/signupValidation';
	import { finalSignupValidation } from '$lib/helpers/validations/registration/signupValidation';
	import { z } from 'zod';
	import { page } from '$app/stores';

	import 'svelte-tel-input/styles/flags.css';
	import { TelInput, normalizedCountries } from 'svelte-tel-input';

	// Initialize selectedCountry with the correct format (uppercase)
	let selectedCountry = 'PH';

	// You must use E164 number format. It's guarantee the parsing and storing consistency.
	let Value = '';

	// Validity
	let valid = true;

	// Optional - Extended details about the parsed phone number
	let detailedValue = null;

	let inviteId = $page.data.inviteId;

	// Form page control
	let step = 1;

	// page 1 validation
	const step1FormData = {};

	let validationResult = {
		isValid: false,
		errors: {}
	};

	function step1Validation() {
		validationResult.result = null;
		validationResult.errors = {};
		try {
			validationResult.result = signUpPageOneValidation.parse(step1FormData);
			validationResult.isValid = true;

			$form.firstname = step1FormData.firstname;
			$form.lastname = step1FormData.lastname;
			$form.mobileNumber = step1FormData.mobileNumber;
			$form.position = step1FormData.position;
			$form.password = step1FormData.password;
			$form.email = step1FormData.email;
			step += 1;
		} catch (error) {
			const { fieldErrors: errors } = error.flatten();
			validationResult.errors = errors;
		}
	}

	$: {
		step1FormData.firstname = $form.firstname;
		step1FormData.lastname = $form.lastname;
		step1FormData.mobileNumber = $form.mobileNumber;
		step1FormData.position = $form.position;
		step1FormData.password = $form.password;
		step1FormData.email = $form.email;
	}

	// ====> super forms
	export let data;
	const { form, errors, constraints, enhance } = superForm(data.form, {
		taintedMessage: 'Do you want to leave this page? Changes you made may not be saved.',
		validators: finalSignupValidation,
		onSubmit: ({ formData }) => {
			mixpanel.identify(step1FormData.email);
			mixpanel.track('Signup');
			mixpanel.people.set_once({
				$first_name: step1FormData.firstname || '',
				$last_name: step1FormData.lastname || '',
				$email: step1FormData.email
			});
			showLoadingModal = true;
			formData.append('firstname', step1FormData.firstname);
			formData.append('lastname', step1FormData.lastname);
			formData.append('mobileNumber', step1FormData.mobileNumber);
			formData.append('position', step1FormData.position);
			formData.append('email', step1FormData.email);
			formData.append('password', step1FormData.password);
		},
		onResult: ({ result }) => {
			if (result.type === 'success') {
				// login user after success sign  up
				// @ts-ignore
				Crisp.user.setEmail($form.email);
				// @ts-ignore
				Crisp.user.setNickname($form.firstname + ' ' + $form.lastname);

				Crisp.session.setData({
					// @ts-ignore
					email: $form.email,
					// @ts-ignore
					name: $form.firstname + ' ' + $form.lastname
				});
				signInHandle($form.email, $form.password);
			}

			if (result.type === 'error') {
				showLoadingModal = false;
				modalTitle = 'Something went wrong.';
				modalMessage = result.error.message;
				showFormModal = true;
			}
		},
		onError: ({ result }) => {
			if (result.error.message) {
				showLoadingModal = false;
				let fields;
				let fieldWithErrors = {};
				fieldWithErrors = result.error.message;
				Object.keys(fieldWithErrors).forEach((key) => {
					if (!fields) {
						fields = caps(key);
					} else {
						fields = fields + ' and ' + caps(key);
					}
				});
				modalTitle = `${fields} already exist!`;
				let errorText = `Uh-oh! It appears that the ${fields} you're trying to use is already associated with an account.`;
				modalMessage = errorText;
				validationResult.errors = fieldWithErrors;
				let currentErrors = validationResult.errors;
				if (currentErrors.email) {
					step = 1;
				}
				if (fieldWithErrors.email) {
					validationResult.errors.email = fieldWithErrors['email'];
				}
				if (fieldWithErrors.username) {
					$errors.username = fieldWithErrors['username'];
				}

				showFormModal = true;
			} else {
				showLoadingModal = false;
				modalTitle = 'Something went wrong.';
				let errorText = result.error.message + '. Code:' + result.status;
				modalMessage = errorText;
				showFormModal = true;
			}
		}
	});

	function caps(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	async function signInHandle(email, password) {
		await signIn('credentials', {
			email: email,
			password: password,
			callbackUrl: inviteId ? `/dashboard?inviteId=${inviteId}` : `/dashboard`
		});
	}

	// show password
	let showPassword = false;
	const showPassHandler = () => {
		showPassword = !showPassword;
	};
	// Show loading modal
	let showLoadingModal = false;

	// styling variables
	let welcomeText = 'text-main-color font-semibold text-2xl';
	// let welcomeSubText = 'text-text-color font-semibold text-lg  mt-5';
	let socialButtons =
		'btn gap-2 bg-white w-full border-solid border-2 border-social-btn-border text-text-color normal-case text-base font-normal mb-3 hover:bg-white hover:border-social-btn-border';
	let modalMessage;
	let modalTitle = 'Incomplete details';
	let showFormModal = false;

	// username validation ui
	let usernameErrors = [];
	let usernameValidation = z.object({
		username: z
			.string({ required_error: 'Username is required' })
			.min(6, { message: 'Username must be at least 6 characters.' })
			.max(20, { message: 'Username must be less than 20 characters.' })
			.regex(new RegExp('^(?![0-9]*$)[a-zA-Z0-9]+$'), {
				message: 'Domain name can only contain letters and numbers.'
			})
	});

	function checkUsername(event) {
		$form.username = event.target.value.toLowerCase();
		usernameErrors = [];
		let test = {
			username: $form.username
		};
		try {
			usernameValidation.parse(test);
		} catch (error) {
			const { fieldErrors: errors } = error.flatten();
			usernameErrors = errors.username;
		}

		if (!/[a-zA-Z]/.test($form.username)) {
			usernameErrors.push('Username should contain at least one letter.');
		}
	}

	// $: {
	// 	if (Object.keys($errors).length >= 1) {
	// 		showLoadingModal = false;
	// 	}
	// }
</script>

{#if false}
	<SuperDebug data={$form} />
{/if}

<LoadingModal showModal={showLoadingModal} />

<!-- Form Error Modal -->
<ErrorModal title={modalTitle} isOpen={showFormModal} message={modalMessage}>
	<div class="flex justify-center">
		<button
			type="button"
			class="bg-green-700 text-white hover:bg-green-900 py-2 px-4 rounded"
			on:click={() => (showFormModal = false)}
		>
			Close</button
		>
	</div>
</ErrorModal>

<div class="main-container lg:flex">
	<div id="main-content-wrapper" class="w-full px-[24px] lg:w-7/12">
		<div id="title-and-social-wrapper" class=" max-w-[400px] mx-auto">
			<!-- <img
				src="/images/logo-with-text.svg"
				alt="dazle-logo"
				class="w-[108px] h-[42px] mx-auto mt-[30px] md:mt-[55px] lg:mx-0"
			/> -->
			<h1 class="text-[#1F4BC6] font-semibold text-base mt-[26px]">Step {step} out of 2</h1>
			<h1 class="{welcomeText} mt-[16px] {step === 2 ? 'mb-10' : ''}">
				{#if step === 1}
					Sign up. Create an account
				{:else}
					One last step.
				{/if}
			</h1>
			{#if step === 1}
				<div id="social-btns-wrapper" class="mt-[16px]">
					<button
						class={socialButtons}
						on:click={() =>
							signIn('google', {
								callbackUrl: inviteId
									? `${PUBLIC_SITE_URL}/signup/setup-profile?inviteId=${inviteId}`
									: `${PUBLIC_SITE_URL}/signup/setup-profile`
							})}
					>
						<img src="/images/google-icon.svg" class="w-[26px] h-[25px]" alt="google-icon" />
						Sign up with Google
					</button>
				</div>
			{/if}
		</div>
		<!-- Divider -->
		{#if step === 1}
			<div class="divider text-grey-hint-two text-sm max-w-[400px] mx-auto">
				or sign up using your Email address
			</div>
		{/if}
		<div id="login-form-wrapper" class="max-w-[400px] mx-auto">
			<div id="form-wrapper" class="">
				<form method="POST" action="/signup?/register" use:enhance>
					<div class="overflow-hidden">
						{#if !validationResult.isValid || step === 1}
							<div class="step-1">
								<div class="bg-white px-1">
									<div class="grid grid-cols-6 gap-3">
										<div class="col-span-6 mt-0">
											<label for="firstname" class="block label-text leading-7">First name</label>
											{#if validationResult.errors?.firstname}
												<label for="firstname" class="label">
													{#each validationResult.errors.firstname as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}
											<input
												type="text"
												bind:value={$form.firstname}
												name="firstname"
												id="first-name"
												placeholder="First name"
												class="input input-bordered w-full"
												{...$constraints.firstname}
											/>
										</div>
										<div class="col-span-6 mt-0">
											<label for="lastname" class="block label-text leading-7">Last name</label>
											{#if validationResult.errors?.lastname}
												<label for="lastname" class="label">
													{#each validationResult.errors.lastname as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}
											<input
												type="text"
												bind:value={$form.lastname}
												name="lastname"
												id="lastname"
												placeholder="Last name"
												class="input input-bordered w-full"
												{...$constraints.lastname}
											/>
										</div>

										<div class="col-span-6 mt-0">
											<label for="mobileNumber" class="block label-text leading-7"
												>Mobile Number</label
											>
											<div class="flex h-auto">
												<div
													class="p-[1px] ounded-lg w-full focus-within:rounded-lg focus-within:border-slate-300 focus-within:border-[2px]"
												>
													<div class="flex border-2 p-3 rounded-lg w-full">
														<select
															class="country-select w-[100px] h-full outline-none {!valid
																? 'invalid'
																: ''}"
															aria-label="Default select example"
															name="Country"
															bind:value={selectedCountry}
														>
															<option value={null} hidden={selectedCountry !== null}
																>Please select</option
															>
															{#each normalizedCountries as currentCountry (currentCountry.id)}
																<option
																	value={currentCountry.iso2}
																	selected={currentCountry.iso2 === selectedCountry}
																	aria-selected={currentCountry.iso2 === selectedCountry}
																>
																	{currentCountry.iso2} (+{currentCountry.dialCode})
																</option>
															{/each}
														</select>
														{#if selectedCountry !== null}
															<img
																src={`https://flagcdn.com/w40/${selectedCountry.toLowerCase()}.png`}
																alt="Flag"
																class="flag h-[25px] w-[25px] my-auto"
															/>
														{/if}
													</div>
												</div>
												<div
													class="p-[1px] ml-0 md:ml-2 focus-within:rounded-lg focus-within:border-slate-300 focus-within:border-[2px]"
												>
													<TelInput
														bind:value={$form.mobileNumber}
														type="tel"
														placeholder="Enter Mobile Number"
														name="inquirerNumber"
														id="inquirerNumber"
														required
														bind:country={selectedCountry}
														bind:Value
														bind:valid
														{...$constraints.mobileNumber}
														bind:detailedValue
														class="basic-tel-input p-3 text-slate-500 border-[1px] border-slate-300 rounded-lg w-[200px] focus:outline-none  {!valid
															? 'invalid'
															: ''}"
													/>
												</div>

												{#if validationResult.errors?.mobileNumber}
													<label for="mobileNumber" class="label">
														{#each validationResult.errors.mobileNumber as error}
															<span class="label-text-alt text-error">{error}</span>
														{/each}
													</label>
												{/if}
											</div>
										</div>
										<div class="col-span-6 mt-0">
											<label for="position" class="block label-text leading-7"
												>I am a Real Estate ..</label
											>

											<select
												id="position"
												bind:value={$form.position}
												name="position"
												class="select select-bordered w-full"
											>
												<!-- <option disabled selected>Pick your favorite Simpson</option> -->
												<option>Broker</option>
												<option>Salesperson</option>
											</select>
											{#if validationResult.errors?.position}
												<label for="position" class="label">
													{#each validationResult.errors.position as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}
										</div>
										<div class="col-span-6 mt-0">
											<!-- <label for="firstname" class="block text font-medium leading-6 text-gray-900">First name</label> -->
											<label for="firstname" class="block label-text leading-7">Email</label>
											{#if validationResult.errors?.email}
												{#each validationResult.errors.email as error}
													<label for="email" class="label">
														<span class="label-text-alt text-error">{error}</span>
													</label>
												{/each}
											{/if}
											<input
												type="email"
												bind:value={$form.email}
												name="email"
												id="emial"
												placeholder="Email"
												class="input input-bordered w-full"
												{...$constraints.email}
											/>
										</div>
										<div class="col-span-6 mt-0">
											<!-- <label for="firstname" class="block text font-medium leading-6 text-gray-900">First name</label> -->
											<label for="firstname" class="block label-text leading-7">Password</label>
											{#if validationResult.errors?.password}
												<label for="password" class="label">
													{#each validationResult.errors.password as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}
											<div class="relative">
												{#if showPassword}
													<input
														type="text"
														name="password"
														id="password"
														placeholder="Password"
														class="input input-bordered w-full"
														bind:value={$form.password}
													/>
												{:else}
													<input
														type="password"
														name="password"
														id="password"
														placeholder="Password"
														class="input input-bordered w-full"
														bind:value={$form.password}
													/>
												{/if}

												<div
													class="absolute top-4 right-4 cursor-pointer"
													on:click={showPassHandler}
													aria-hidden="true"
												>
													{#if showPassword}
														<img src="images/hide-icon.svg" alt="show-pass-icon" class="w-[20px]" />
													{:else}
														<img
															src="images/unhide-icon.svg"
															alt="show-pass-icon"
															class="w-[20px] h-[21px]"
														/>
													{/if}
												</div>
											</div>
										</div>
									</div>
									<button
										type="button"
										on:click={step1Validation}
										class="btn bg-main-color ml-auto mt-5 border-none px-10 w-full hover:bg-main-color"
									>
										<p class="text-white normal-case">Next</p>
									</button>
								</div>
							</div>
						{:else}
							<div class="step-2">
								<div class="bg-white px-1">
									<div class="grid grid-cols-6 gap-3">
										<div class="col-span-6 mt-0">
											<label for="username" class="block label-text leading-7"
												>My Dazle Domain name</label
											>
											{#if $errors.username}
												<label for="firstname" class="label">
													{#each $errors.username as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}

											<div class="relative">
												<input
													required
													type="text"
													placeholder="Your Dazle Domain name"
													name="username"
													id="username"
													class="input input-bordered w-full {usernameErrors.length >= 1
														? 'input-warning'
														: ''} {usernameErrors.length === 0 && $form.username
														? 'input-success'
														: ''}"
													bind:value={$form.username}
													on:input={checkUsername}
												/>
												<div class="absolute top-3 right-4" aria-hidden="true">
													{#if $form.username}
														{#if usernameErrors.length >= 1}
															<svg
																width="22"
																height="20"
																viewBox="0 0 22 20"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	d="M10.9998 7.99994V11.7499M1.69653 15.1256C0.831142 16.6256 1.91371 18.4999 3.64544 18.4999H18.3541C20.0858 18.4999 21.1684 16.6256 20.303 15.1256L12.9487 2.37807C12.0828 0.877233 9.91672 0.877233 9.05085 2.37807L1.69653 15.1256ZM10.9998 14.7499H11.0073V14.7574H10.9998V14.7499Z"
																	stroke="#fbbd23"
																	stroke-width="1.5"
																	stroke-linecap="round"
																	stroke-linejoin="round"
																/>
															</svg>
														{:else}
															<svg
																width="26"
																height="26"
																viewBox="0 0 26 26"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	d="M9 12.75L11.25 15L15 9.75M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
																	stroke="#36d399"
																	stroke-width="1.5"
																	stroke-linecap="round"
																	stroke-linejoin="round"
																/>
															</svg>
														{/if}
													{/if}
												</div>
											</div>
											{#if usernameErrors.length >= 1}
												{#each usernameErrors as error}
													<!-- <label for="username" class="label mb-0"> -->
													<p class="text-xs mt-1 mb-0 text-warning">{error}</p>
													<!-- </label> -->
												{/each}
											{/if}
											<p class="description text-xs text-[#858585] mt-1 w-full max-w-xs">
												Your dazle URL: https://{$form.username ?? ''}.dazle.site
											</p>
										</div>

										<div class="col-span-6 mt-0">
											<label for="lastname" class="block label-text leading-7">Display Email</label>
											<input
												type="email"
												bind:value={$form.displayEmail}
												name="displayEmail"
												id="displayEmail"
												placeholder="Display Email"
												class="input input-bordered w-full"
												{...$constraints.displayEmail}
											/>
											{#if $errors.displayEmail}
												<label for="displayEmail" class="label">
													{#each $errors.displayEmail as error}
														<span class="label-text-alt text-error">{error}</span>
													{/each}
												</label>
											{/if}
										</div>
									</div>
								</div>
							</div>
							<div class="flex">
								<button
									type="button"
									on:click={() => {
										step = step - 1;
									}}
									class="btn bg-white-btn mr-auto mt-5 border-none text-text-color px-10 hover:bg-white-btn"
								>
									<p class="normal-case">Previous</p>
								</button>
								<button
									type="submit"
									class="btn bg-main-color ml-auto mt-5 border-none px-10 hover:bg-main-color"
								>
									<p class="text-white normal-case">Sign up</p>
								</button>
							</div>
						{/if}
					</div>
				</form>
			</div>
			<span class="text-sm text-center">
				<p class="display-inline mt-6">
					Already have an account? <a href="/login" class="text-[#1f4bc6]">Log in</a>
				</p>
			</span>
		</div>
	</div>
	<!-- Hero Section -->
	<div
		id="hero-wrapper"
		class="hidden lg:block bg-login-bg-img lg:w-5/12 min-h-fit bg-no-repeat bg-cover bg-center pl-[47px]"
	>
		<img src="/images/new-logo.svg" alt="dazle-logo" class="mt-16 max-h-8" />

		<h1 id="hero-text" class="text-3xl text-white font-semibold mb-7 mt-5 leading-normal">
			Tools you need to grow your Real Estate business
		</h1>

		<p class="text-white mb-12 text-lg">
			<span style="display: block; margin-bottom: 10px;">• Upload and Manage your listings</span>
			<span style="display: block; margin-bottom: 10px;">• Sellers Website</span>
			<span style="display: block; margin-bottom: 10px;">• Contact forms to get leads</span>
			<span style="display: block; margin-bottom: 10px;"
				>• Get leads and referrals for your buyers needs</span
			>
		</p>

		<img
			src="/images/dazle-login.svg"
			alt="mockup"
			class=" min-h-[450px] max-h-[580px] w-full ml-0 object-cover object-left-top"
		/>
	</div>
</div>

<style>
	button:hover {
		box-shadow: inset 0em 0em 0em 10em rgba(0, 0, 0, 0.3);
	}
</style>
